import React from 'react';
import { Grid, Paper, Typography, Box, Container, Chip } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PeopleIcon from '@mui/icons-material/People';

function FeatureCard(props) {
  const { image, icon, title, description } = props;

  return (
    <Paper
      elevation={0}
      sx={{
        height: '100%',
        borderRadius: '22px',
        border: '1px solid rgba(17,24,39,0.07)',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
        '&:hover': {
          boxShadow: '0 22px 45px rgba(19,95,151,0.12)',
          transform: 'translateY(-8px)',
          borderColor: 'rgba(32,133,216,0.25)',
        },
      }}
    >
      {/* Image with floating icon badge */}
      <Box sx={{ position: 'relative' }}>
        <Box
          component="img"
          src={image}
          alt={title}
          loading="lazy"
          decoding="async"
          sx={{
            width: '100%',
            aspectRatio: '4 / 3',
            objectFit: 'cover',
            display: 'block',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: -26,
            left: 24,
            width: 56,
            height: 56,
            borderRadius: '18px',
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            background: 'linear-gradient(135deg, #2085D8, #0EA5E9)',
            boxShadow: '0 12px 24px rgba(32,133,216,0.35)',
          }}
        >
          {icon}
        </Box>
      </Box>

      <Box sx={{ p: 3, pt: 5, textAlign: 'left' }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          {title}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
          {description}
        </Typography>
      </Box>
    </Paper>
  );
}

function FeaturesSection() {
  return (
    <Box component="section" id="features" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 8 } }}>
          <Chip
            label="Features"
            sx={{
              mb: 2,
              fontWeight: 600,
              color: '#135F97',
              backgroundColor: 'rgba(32,133,216,0.10)',
            }}
          />
          <Typography variant="h3" component="h2" sx={{ fontSize: { xs: '2rem', md: '2.75rem' }, mb: 1.5 }}>
            Why choose <span className="gradient-text">Cizlot</span>?
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 620, mx: 'auto' }}>
            Everything customers and salon owners need — in one simple, reliable app.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <FeatureCard
              image="/img1.png"
              icon={<CalendarTodayIcon sx={{ fontSize: 28 }} />}
              title="Easy Booking"
              description="Book appointments anytime, anywhere with our smooth and reliable booking experience."
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FeatureCard
              image="/img6.jpg"
              icon={<StorefrontIcon sx={{ fontSize: 28 }} />}
              title="Business Management"
              description="Powerful tools to manage staff, services, schedules, and daily operations efficiently."
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FeatureCard
              image="/img2.png"
              icon={<PeopleIcon sx={{ fontSize: 28 }} />}
              title="Customer Relations"
              description="Engage customers, track visits, and build long-term loyalty effortlessly."
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default FeaturesSection;
